// Constant used for select in device creation page
export const DeviceModels = [
    { "value" : "B01"},
    { "value" : "B02"},
];
